/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Subtitle_Import_Auto_Offset_TextInputs */

const en_subtitle_import_auto_offset_text = /** @type {(inputs: Subtitle_Import_Auto_Offset_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The subtitle file you are importing has an offset of ${i?.timecode}. Would you like to apply an automatic offset and update the project incode to match?`)
};

const fr_subtitle_import_auto_offset_text = /** @type {(inputs: Subtitle_Import_Auto_Offset_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le fichier de sous-titres que vous importez a un decalage de ${i?.timecode}. Voulez-vous appliquer un decalage automatique et mettre a jour l'incode du projet ?`)
};

const de_subtitle_import_auto_offset_text = /** @type {(inputs: Subtitle_Import_Auto_Offset_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die importierte Untertiteldatei hat einen Offset von ${i?.timecode}. Möchten Sie einen automatischen Offset anwenden und den Projekt-Incode entsprechend aktualisieren?`)
};

const it_subtitle_import_auto_offset_text = /** @type {(inputs: Subtitle_Import_Auto_Offset_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il file dei sottotitoli che stai importando ha un offset di ${i?.timecode}. Vuoi applicare un offset automatico e aggiornare il codice sorgente del progetto di conseguenza?`)
};

const ru_subtitle_import_auto_offset_text = /** @type {(inputs: Subtitle_Import_Auto_Offset_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`В импортируемом файле субтитров используется смещение ${i?.timecode}. Хотите ли вы применить автоматическое смещение и обновить код проекта в соответствии с ним?`)
};

const es_subtitle_import_auto_offset_text = /** @type {(inputs: Subtitle_Import_Auto_Offset_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El archivo de subtítulos que estás importando tiene un desplazamiento de ${i?.timecode}. ¿Quieres aplicar un desplazamiento automático y actualizar el código de entrada del proyecto para que coincida?`)
};

const zh_cn2_subtitle_import_auto_offset_text = /** @type {(inputs: Subtitle_Import_Auto_Offset_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您导入的字幕文件偏移量为${i?.timecode}。您是否要应用自动偏移量并更新项目编码以匹配？`)
};

const ja_subtitle_import_auto_offset_text = /** @type {(inputs: Subtitle_Import_Auto_Offset_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`インポートしようとしている字幕ファイルのオフセットは${i?.timecode}です。自動オフセットを適用し、プロジェクトのインコードもそれに合わせて更新しますか？`)
};

const hi_subtitle_import_auto_offset_text = /** @type {(inputs: Subtitle_Import_Auto_Offset_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आप जिस सबटाइटल फ़ाइल को इम्पोर्ट कर रहे हैं, उसका ऑफ़सेट ${i?.timecode} है। क्या आप स्वचालित ऑफ़सेट लागू करना और प्रोजेक्ट इनकोड को उससे मेल खाने के लिए अपडेट करना चाहेंगे?`)
};

const pt_pt2_subtitle_import_auto_offset_text = /** @type {(inputs: Subtitle_Import_Auto_Offset_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O arquivo de legenda que você está importando tem um deslocamento de ${i?.timecode}. Deseja aplicar um deslocamento automático e atualizar o código de entrada do projeto para corresponder?`)
};

/**
* | output |
* | --- |
* | "The subtitle file you are importing has an offset of {timecode}. Would you like to apply an automatic offset and update the project incode to match?" |
*
* @param {Subtitle_Import_Auto_Offset_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_auto_offset_text = /** @type {((inputs: Subtitle_Import_Auto_Offset_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Auto_Offset_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_auto_offset_text(inputs)
	if (locale === "de") return de_subtitle_import_auto_offset_text(inputs)
	if (locale === "it") return it_subtitle_import_auto_offset_text(inputs)
	if (locale === "ru") return ru_subtitle_import_auto_offset_text(inputs)
	if (locale === "es") return es_subtitle_import_auto_offset_text(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_auto_offset_text(inputs)
	if (locale === "ja") return ja_subtitle_import_auto_offset_text(inputs)
	if (locale === "hi") return hi_subtitle_import_auto_offset_text(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_auto_offset_text(inputs)
	return en_subtitle_import_auto_offset_text(inputs)
});